import { render, staticRenderFns } from "./SessionFooterNav.vue?vue&type=template&id=21d83cdd&scoped=true&"
import script from "./SessionFooterNav.vue?vue&type=script&lang=js&"
export * from "./SessionFooterNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d83cdd",
  null
  
)

export default component.exports